import dayjs from 'dayjs'
import { noContentPlaceholder } from 'ufinet-web-functions'

const dateFormat = 'YYYY-MM-DD'

export const formatDateOrDefualt = (date: Date | null, format?: string): string => {
	return date ? dayjs(date).format(format ?? dateFormat) : noContentPlaceholder
}
